export default function ProgressBar({
  step,
  variant = 'v1',
  landingPage,
}: {
  step: number;
  variant?: 'v1' | 'v2' | 'v3';
  landingPage?: string;
}): JSX.Element {
  const isStepTwo = step >= 2 ? 'active' : '';
  const isStepThree = step >= 3 ? 'active' : '';
  const isStepFour = step >= 4 ? 'active' : '';
  const isStepFive = step >= 5 ? 'active' : '';
  const isStepSix = step >= 6 ? 'active' : '';
  const isStepSeven = step >= 7 ? 'active' : '';

  if (landingPage === 'v12' || landingPage === 'v13') {
    return (
      <ul className="flex flex-wrap list-none mb-8 md:justify-between justify-center">
        <li className="md:bg-red-200  sm:py-2 sm:px-6 rounded-xl flex items-center text-black md:font-thin font-bold text-sm md:text-base">
          <a className="cursor-default" href="#">
            <span className="block sm:hidden">Basic</span>
            <span className="hidden sm:block">Basic details</span>
          </a>
          <hr
            className={`mx-4 block w-8 border-t-2 ${
              isStepTwo ||
              isStepThree ||
              isStepFour ||
              isStepFive ||
              isStepSix ||
              isStepSeven
                ? 'bg-black border-black'
                : 'bg-gray-400'
            } sm:hidden`}
          />
        </li>
        <li
          className={`sm:py-2 sm:px-6 rounded-xl md:font-thin flex items-center font-bold text-sm md:text-base ${
            isStepTwo
              ? 'md:bg-red-200 text-black'
              : 'text-gray-400 md:text-black'
          }`}
        >
          <a className="cursor-default" href="#">
            <span className="block sm:hidden">Personal</span>
            <span className="hidden sm:block">Personal details</span>
          </a>
          <hr
            className={`mx-4 block w-8 border-t-2 ${
              isStepThree ||
              isStepFour ||
              isStepFive ||
              isStepSix ||
              isStepSeven
                ? 'bg-black border-black'
                : 'bg-gray-400'
            } sm:hidden`}
          />
        </li>
        <li
          className={`sm:py-2 sm:px-6 rounded-xl md:font-thin flex items-center font-bold text-sm md:text-base ${
            isStepThree
              ? 'md:bg-red-200 text-black'
              : 'text-gray-400 md:text-black'
          }`}
        >
          <a className="cursor-default" href="#">
            <span className="block sm:hidden">Address</span>
            <span className="hidden sm:block">Address details</span>
          </a>
          <hr
            className={`mx-4 block w-8 border-t-2 ${
              isStepFour || isStepFive || isStepSix || isStepSeven
                ? 'bg-black border-black'
                : 'bg-gray-400'
            } sm:hidden`}
          />
        </li>
        <li
          className={`sm:py-2 sm:px-6 rounded-xl md:font-thin flex items-center font-bold text-sm md:text-base ${
            isStepFour
              ? 'md:bg-red-200 text-black'
              : 'text-gray-400 md:text-black'
          }`}
        >
          <a className="cursor-default" href="#">
            <span className="block sm:hidden">Security</span>
            <span className="hidden sm:block">Security details</span>
          </a>
          <hr
            className={`mx-4 block w-8 border-t-2 ${
              isStepFive || isStepSix || isStepSeven
                ? 'bg-black border-black'
                : 'bg-gray-400'
            } sm:hidden`}
          />
        </li>
        <li
          className={`sm:py-2 sm:px-6 rounded-xl md:font-thin flex items-center font-bold text-sm md:text-base ${
            isStepFive
              ? 'md:bg-red-200 text-black'
              : 'text-gray-400 md:text-black'
          }`}
        >
          <a className="cursor-default" href="#">
            Confirmation
          </a>
          <hr
            className={`mx-4 block w-8 border-t-2 ${
              isStepSix || isStepSeven ? 'bg-black border-black' : 'bg-gray-400'
            } sm:hidden`}
          />
        </li>
        <li
          className={`sm:py-2 sm:px-6 rounded-xl md:font-thin flex items-center font-bold text-sm md:text-base ${
            isStepSix
              ? 'md:bg-red-200 text-black'
              : 'text-gray-400 md:text-black'
          }`}
        >
          <a className="cursor-default" href="#">
            Payment
          </a>
          <hr
            className={`mx-4 block w-8 border-t-2 ${
              isStepSeven ? 'bg-black border-black' : 'bg-gray-400'
            } sm:hidden`}
          />
        </li>
        <li
          className={`sm:py-2 sm:px-6 cursor-default rounded-xl md:font-thin font-bold text-sm md:text-base ${
            isStepSeven
              ? 'md:bg-red-200 text-black'
              : 'text-gray-400 md:text-black'
          }`}
        >
          <a className="cursor-default" href="#">
            Done
          </a>
        </li>
      </ul>
    );
  }

  if (variant === 'v1') {
    return (
      <ul className="steps-nav">
        <li className="step-1 active">
          <a href="#">Basic details</a>
        </li>
        <li className={`step-2 ${isStepTwo}`}>
          <a href="#">
            Personal
            <br /> details
          </a>
        </li>
        <li className={`step-3 ${isStepThree}`}>
          <a href="#">
            Address
            <br /> details
          </a>
        </li>
        <li className={`step-4 ${isStepFour}`}>
          <a href="#">
            Security
            <br /> details
          </a>
        </li>
        <li className={`step-4 ${isStepFive}`}>
          <a href="#">Confirmation</a>
        </li>
        <li className={`step-6 ${isStepSix}`}>
          <a href="#">Payment</a>
        </li>
        <li className={`step-7 ${isStepSeven}`}>
          <a href="#">Done</a>
        </li>
      </ul>
    );
  }

  if (variant === 'v2') {
    return (
      <ul className="my-8 space-y-4 md:flex md:space-y-0 md:space-x-8">
        <li className="md:flex-1">
          <h3
            className={`text-xs leading-4 font-semibold uppercase text-primary`}
          >
            Step 1
          </h3>
          <p className="leading-5 font-medium">Basic details</p>
        </li>
        <li className="md:flex-1">
          <h3
            className={`text-xs leading-4 font-semibold uppercase ${
              isStepTwo && 'text-primary'
            }`}
          >
            Step 2
          </h3>
          <p className="leading-5 font-medium">Personal Details</p>
        </li>
        <li className="md:flex-1">
          <h3
            className={`text-xs leading-4 font-semibold uppercase ${
              isStepThree && 'text-primary'
            }`}
          >
            Step 3
          </h3>
          <p className="leading-5 font-medium">Address Details</p>
        </li>
        <li className="md:flex-1">
          <h3
            className={`text-xs leading-4 font-semibold uppercase ${
              isStepFour && 'text-primary'
            }`}
          >
            Step 4
          </h3>
          <p className="leading-5 font-medium">Security Details</p>
        </li>
        <li className="md:flex-1">
          <h3
            className={`text-xs leading-4 font-semibold uppercase ${
              isStepFive && 'text-primary'
            }`}
          >
            Step 5
          </h3>
          <p className="leading-5 font-medium">Confirmation</p>
        </li>
        <li className="md:flex-1">
          <h3
            className={`text-xs leading-4 font-semibold uppercase ${
              isStepSix && 'text-primary'
            }`}
          >
            Step 6
          </h3>
          <p className="leading-5 font-medium">Payment</p>
        </li>
        <li className="md:flex-1">
          <h3
            className={`text-xs leading-4 font-semibold uppercase ${
              isStepSeven && 'text-primary'
            }`}
          >
            Step 7
          </h3>
          <p className="leading-5 font-medium">Done</p>
        </li>
      </ul>
    );
  }

  if (variant === 'v3') {
    return (
      <ul className="mb-14 sm:flex sm:items-center">
        <li className="list-decimal pl-2 ml-6 sm:ml-0 sm:pl-0 sm:list-none relative pr-8 sm:pr-20 w-full">
          <div className="hidden absolute inset-0 sm:flex sm:items-center">
            <div
              className={`h-1 w-full bg-box-${
                isStepTwo ? 'header' : 'background'
              }`}
            ></div>
          </div>
          <div className="relative">
            <div className="hidden bg-white relative w-8 h-8 sm:flex items-center justify-center border-4 border-box-header rounded-full"></div>
            <h3 className="sm:absolute pt-2 text-sm sm:text-xs md:text-sm leading-4 font-semibold uppercase tracking-wide text-box-header mx-auto left-0 right-0">
              Basic Details
            </h3>
          </div>
        </li>

        <li className="list-decimal pl-2 ml-6 sm:ml-0 sm:pl-0 sm:list-none relative pr-8 sm:pr-20 w-full">
          <div className="hidden absolute inset-0 sm:flex sm:items-center">
            <div
              className={`h-1 w-full bg-box-${
                isStepThree ? 'header' : 'background'
              }`}
            ></div>
          </div>
          <div className="relative">
            <div
              className={`hidden bg-white relative w-8 h-8 sm:flex items-center justify-center border-4 border-box-${
                isStepTwo ? 'header' : 'background'
              } rounded-full`}
            ></div>
            <h3 className="sm:absolute pt-2 text-sm sm:text-xs md:text-sm leading-4 font-semibold uppercase tracking-wide text-box-header mx-auto left-0 right-0">
              Personal Details
            </h3>
          </div>
        </li>

        <li className="list-decimal pl-2 ml-6 sm:ml-0 sm:pl-0 sm:list-none relative pr-8 sm:pr-20 w-full">
          <div className="hidden absolute inset-0 sm:flex sm:items-center">
            <div
              className={`h-1 w-full bg-box-${
                isStepFour ? 'header' : 'background'
              }`}
            ></div>
          </div>
          <div className="relative">
            <div
              className={`hidden bg-white relative w-8 h-8 sm:flex items-center justify-center border-4 border-box-${
                isStepThree ? 'header' : 'background'
              } rounded-full`}
            ></div>
            <h3 className="sm:absolute pt-2 text-sm sm:text-xs md:text-sm leading-4 font-semibold uppercase tracking-wide text-box-header mx-auto left-0 right-0">
              Address Details
            </h3>
          </div>
        </li>

        <li className="list-decimal pl-2 ml-6 sm:ml-0 sm:pl-0 sm:list-none relative pr-8 sm:pr-20 w-full">
          <div className="hidden absolute inset-0 sm:flex sm:items-center">
            <div
              className={`h-1 w-full bg-box-${
                isStepFive ? 'header' : 'background'
              }`}
            ></div>
          </div>
          <div className="relative">
            <div
              className={`hidden bg-white relative w-8 h-8 sm:flex items-center justify-center border-4 border-box-${
                isStepFour ? 'header' : 'background'
              } rounded-full`}
            ></div>
            <h3 className="sm:absolute pt-2 text-sm sm:text-xs md:text-sm leading-4 font-semibold uppercase tracking-wide text-box-header mx-auto left-0 right-0">
              Security Details
            </h3>
          </div>
        </li>

        <li className="list-decimal pl-2 ml-6 sm:ml-0 sm:pl-0 sm:list-none relative pr-8 sm:pr-20 w-full">
          <div className="hidden absolute inset-0 sm:flex sm:items-center">
            <div
              className={`h-1 w-full bg-box-${
                isStepSix ? 'header' : 'background'
              }`}
            ></div>
          </div>
          <div className="relative">
            <div
              className={`hidden bg-white relative w-8 h-8 sm:flex items-center justify-center border-4 border-box-${
                isStepFive ? 'header' : 'background'
              } rounded-full`}
            ></div>
            <h3 className="sm:absolute pt-2 text-sm sm:text-xs md:text-sm leading-4 font-semibold uppercase tracking-wide text-box-header mx-auto left-0 right-0">
              Confirmation
            </h3>
          </div>
        </li>

        <li className="list-decimal pl-2 ml-6 sm:ml-0 sm:pl-0 sm:list-none relative pr-8 sm:pr-20 w-full">
          <div className="hidden absolute inset-0 sm:flex sm:items-center">
            <div
              className={`h-1 w-full bg-box-${
                isStepSeven ? 'header' : 'background'
              }`}
            ></div>
          </div>
          <div className="relative">
            <div
              className={`hidden bg-white relative w-8 h-8 sm:flex items-center justify-center border-4 border-box-${
                isStepSix ? 'header' : 'background'
              } rounded-full`}
            ></div>
            <h3 className="sm:absolute pt-2 text-sm sm:text-xs md:text-sm leading-4 font-semibold uppercase tracking-wide text-box-header mx-auto left-0 right-0">
              Payment
            </h3>
          </div>
        </li>

        <li className="list-decimal pl-2 ml-6 sm:ml-0 sm:pl-0 sm:list-none relative">
          <div className="hidden absolute inset-0 sm:flex sm:items-center">
            <div
              className={`h-1 w-full bg-box-${
                isStepSeven ? 'header' : 'background'
              }`}
            ></div>
          </div>
          <div className="relative">
            <div
              className={`hidden bg-white relative w-8 h-8 sm:flex items-center justify-center border-4 border-box-${
                isStepSeven ? 'header' : 'background'
              } rounded-full`}
            ></div>
            <h3 className="sm:absolute pt-2 text-sm sm:text-xs md:text-sm leading-4 font-semibold uppercase tracking-wide text-box-header mx-auto left-0 right-0">
              Done
            </h3>
          </div>
        </li>
      </ul>
    );
  }
}
